// extracted by mini-css-extract-plugin
export default {"summitDropdown":"rGWFww3RTs1gTAFAfoTx","summitSelect":"vCGT1OpqQu5TSrXstEVc","btn":"dbvQjTkXJbOUQ6Qy48Wj","big":"tL2zXEFNDtsdddv8AQ_Q"};